﻿'use strict'
import { App, View } from '../../config/app.js'
import { currentUser, getFileList } from '../../helper.js'
import { Modal } from '../../modal.js'

export default async function ()
{
	const canvas = document.createElement('canvas')
	const context = canvas.getContext('2d')
	const img = new Image()
	const reader = new FileReader()

	let imgContainer
	let logoDisplay
	let file
	let finalImgDisplay
	let finalImgInput
	let removeBtn
	let maxFileSize = 2097152
	let maxWidth
	let maxHeight
	let mimeType = 'image/png'
	let compression

	App.Modal.ImageCropScaler = new Modal('ImageCropScaler', {
		view: View.create({
			name: 'modal/imageCropScaler',
			model: App.Store.modelCreate('storeaccount', currentUser().id)
		}),
		onOpen: (modal, data) =>
		{
			const okBtn = modal.element.querySelector('.btn-primary')
			okBtn.disabled = true

			const imgResizer = modal.element.querySelector('.img-resizer')
			imgContainer = imgResizer.querySelector('.img-container')
			logoDisplay = imgContainer.querySelector('.img-display')
			finalImgDisplay = document.querySelector(data.imgDisplayQuery)
			finalImgInput = document.querySelector(data.imgInputQuery)
			removeBtn = document.querySelector(data.removeBtnQuery)
			
			const imgInputContainer = modal.element.querySelector('[ui-file-input]')
			const imgInput = imgInputContainer.querySelector('input[type="file"]')
			
			img.onload = e =>
			{
				compression = 1.0
				maxWidth = 1600
				maxHeight = 1600
				mimeType = file.type
				okBtn.disabled = false
				imgResizer.classList.remove('hidden')
				imgInputContainer.classList.add('hidden')
				compressImage()
			}

			reader.onloadend = e => img.src = e.target.result

			imgInput.onchange = e =>
			{
				file = getFileList(e)[0]
				reader.readAsDataURL(file)
			}

			imgInput.click()
		},
		
		onClose: modal =>
		{
			setTimeout(() => {
				modal.element.querySelector('.img-resizer').classList.add('hidden')
				modal.element.querySelector('[ui-file-input]').classList.remove('hidden')
			}, 250)
		},

		onActionBefore: (modal, e) =>
		{
			e.preventDefault()

			const dataURL = canvas.toDataURL(mimeType, compression)
			finalImgDisplay.src = dataURL
			finalImgInput.value = dataURL
			removeBtn.classList.remove('hidden')
			modal.close()
		}
	})

	function compressImage()
	{
		if (compression < 1)
			mimeType = 'image/jpeg'

		let width = img.naturalWidth
		let height = img.naturalHeight
		let ratio = 1

		if (width > maxWidth)
		{
			ratio = maxWidth / width
			width *= ratio
			height *= ratio
		}

		if (height > maxHeight)
		{
			ratio = maxHeight / height
			width *= ratio
			height *= ratio
		}

		canvas.width = width
		canvas.height = height
		canvas.style.width = width + 'px';
		canvas.style.height = height + 'px';
		context.scale(1, 1)
		context.drawImage(img, 0, 0, width, height)
		logoDisplay.src = canvas.toDataURL(mimeType, compression)

		if (logoDisplay.src.length > maxFileSize)
		{
			if (compression < 0.8)
			{
				// If the comression is already below 80% shrink max image and reset compression
				maxWidth -= 100
				maxHeight -= 100
				compression = 1.0
				compressImage()
			}
			else
				compressImage(compression -= 0.1) // Increase compression level to fit image into max size
		}
	}

}

document.addEventListener('action.before', e =>
{
	if (e.detail.name !== 'imagecropscaler remove')
		return
	e.preventDefault()
	document.querySelector(e.detail.data.imgInputQuery).value = 'delete'
	document.querySelector(e.detail.data.imgDisplayQuery).src = ''
	e.target.classList.add('hidden')		
})
